import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/site';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-accent-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-black text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200 max-w-md">
              {siteInfo.description}
            </p>
            <p className="mt-4 text-xs text-accent-300">
              <i className="ri-mail-line mr-1"></i>
              {siteInfo.email}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容栏目</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于本站</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/#faq" className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer">
                  常见问题
                </Link>
              </li>
              <li>
                <Link to="/#subscribe" className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer">
                  订阅热点
                </Link>
              </li>
              <li>
                <Link to="/#hot" className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer">
                  今日热榜
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-accent-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-accent-300">
            © {year} {siteInfo.name} · {siteInfo.tagline}
          </p>
          <p className="text-xs text-accent-400">
            本站内容整理自各方公开信息，仅供阅读参考，不构成任何事实认定。
          </p>
        </div>
      </div>
    </footer>
  );
}